import { Waiver } from './Waiver';
export default Waiver